import { isObjectValid } from "@estaly/ui";

const initialState = {
  activePage: null,
};

export default {
  namespaced: true,

  state: initialState,

  getters: {
    isCurrentActivePage: (state) => (pageName) => {
      return isObjectValid(state.activePage) ? state.activePage["name"] === pageName : false;
    },
  },

  mutations: {
    setActivePage(state, activePage) {
      state.activePage = activePage;
    },
  },

  actions: {
    updateActivePage({ commit }, activePage) {
      commit("setActivePage", activePage);
    },
    resetActivePage({ commit }) {
      commit("setActivePage", null);
    },
  },
};
